<template>
  <div class="w-full py-1">
    <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }">
      <transition name="slide-fade">
        <div class="vs-input--label" v-if="innerValue">
          <span class="hrsys-input-label">{{ inputLabel }}</span>
        </div>
      </transition>
      <div style="height: 17px"></div>
      <flat-pickr :config="config" :placeholder="inputLabel" class="w-full py-3" v-bind="$attrs" v-model="innerValue"/>
      <div class="con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to"
           v-if="!!errors[0]">
        <span class="span-text-validation"> {{errors[0]}} </span>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';

  export default {
    props: {
      inputLabel: {},
      name: {},
      rules: {},
      value: {},
      config: {
        type: Object,
        default: () => ({dateFormat: "d M Y"})
      }
    },
    components: {
      flatPickr
    },
    data: () => ({
      innerValue: "",
    }),
    watch: {
      // Handles internal model changes.
      innerValue (newVal) {
        this.$emit("input", newVal);
      },
      // Handles external model changes.
      value (newVal) {
        this.innerValue = newVal;
      }
    },
    created () {
      if (this.value) {
        this.innerValue = this.value;
      }
    }
  }
</script>

<style lang="scss">
  ::placeholder {
    @apply text-gray-500 text-sm font-light;
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    @apply text-gray-500 text-sm font-light;
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
  }

  ::-ms-input-placeholder { /* Microsoft Edge */
    @apply text-gray-500 text-sm font-light;
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
  }
</style>
